import $ from 'jquery';
import debounce from 'lodash.debounce';

export default function () {
  const $window = $(window);
  const $collapsible = $('.collapsing-header');
  let oldScrollTop = 0;

  const collide = () => {
    // Don't do this on mobile
    if ($window.innerWidth() < 768) return;

    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const collapsibleHeight = $collapsible.outerHeight();

    if (scrollTop > oldScrollTop && scrollTop > collapsibleHeight) {
      // Scrolling down
      $collapsible.css('margin-top', collapsibleHeight * -1);
    } else {
      // Scrolling up
      $collapsible.css('margin-top', 0);
    }

    oldScrollTop = scrollTop;
  };
  $window.on('scroll', false, debounce(collide, 100));
}



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/collapse.js